module.exports = __webpack_public_path__ + "static/media/image.9361ac75.svg";